import { GET_USER_PROFILE } from "../actions/types";

const initialState = {
  user: {
    name: "",
    surname: "",
    email: "",
    role: 2
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_USER_PROFILE:
      return {
        ...state,
        user: action.payload
      };
    default:
      return { ...state };
  }
}
